import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ShowLoading from '../../HOC/ShowLoading';
import AddHistoryModal from './AddHistoryModal';
import RemoveHistoryModal from './RemoveHistoryModal';
import SubNavTradeHistory from '../../components/SubNav/SubNavTradeHistory';
import { ContextMenu, Item, ContextMenuProvider, theme } from 'react-contexify';
import { 
  getTradeHistoryInfo, 
  removeTradeHistory, 
  addTradeHistory,
  updateTradeHistoryInput,
  updateDbTradeHistoryInput 
} from '../../actions';
import { 
  Grid, 
  Table, 
  Button, 
  OverlayTrigger, 
  Popover, 
  Glyphicon 
} from 'react-bootstrap';
import { 
  formatDateYYYYMMDD,
  formatPercent 
} from '../Dashboard/Helpers';
import './TradeHistory.css';

class TradeHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAddHistoryModal: false,
      showRemoveHistoryModal: false,
      tradeToRemove: {},
      historyModalData: {
        tradeType: { label: 'Buy', value: 'Buy' },
        symbol: '',
        buyPrice: '',
        sellPrice: '',
        error: '',
        tradeDate: ''
      }
    };
  }

  componentDidMount() {
    this.props.getTradeHistoryInfo({
      portfolioId: this.props.session.activePortfolioUser.portfolio_id
    });
  }

  /* add history modal */

  modalInputChange = (e) => {
    this.setState({
      historyModalData: {
        ...this.state.historyModalData,
        [e.target.name]: e.target.value 
      }
    });
  }

  onDropdownChange = (value) => {
    this.setState({ 
      historyModalData: {
        ...this.state.historyModalData,
        tradeType: value 
      }
    });
  }

  openAddHistoryModal = () => this.setState({ showAddHistoryModal: true })

  closeAddHistoryModal = () => {
    this.setState({ showAddHistoryModal: false });
    this.resetModalFields();
  }

  resetModalFields = () => {
    this.setState({
      tradeToRemove: {},
      historyModalData: {
        tradeType: { label: 'Buy', value: 'Buy' },
        symbol: '',
        buyPrice: '',
        sellPrice: '',
        error: '',
        tradeDate: ''
      }
    });
  }

  newTradeHistory = (e) => {
    e.preventDefault();

    const { symbol, tradeType, buyPrice, sellPrice, tradeDate } = this.state.historyModalData;

    if (!symbol || !tradeType || !tradeDate || !buyPrice ||
      (tradeType.value === 'Sell' && !sellPrice)) {

      this.setState({
        historyModalData: {
          ...this.state.historyModalData,
          error: 'Please fill in all fields.'
        }
      });
    } else {
      const { portfolio_id } = this.props.session.activePortfolioUser;

      this.props.addTradeHistory({
        symbol: symbol,
        tradeType: tradeType.value,
        buyPrice: buyPrice || '',
        sellPrice: sellPrice || '',
        portfolioId: portfolio_id,
        tradeDate: tradeDate || new Date()
      });

      if (tradeType.value === 'Sell') this.closeAddHistoryModal();
        else this.resetModalFields();
    }
  }

  /*********************/

  openRemoveHistoryModal = () => this.setState({ showRemoveHistoryModal: true })

  closeRemoveHistoryModal = () => {
    this.setState({ showRemoveHistoryModal: false });
    this.resetModalFields();
  }

  removeTradeHistoryPopover = (tradeHistoryId, portfolioId) => (
    <Popover id="remove-history-popover" title="Remove from trade history?" style={{ textAlign: 'center' }}>
      <Button
        className="popover-cancel"
        bsStyle="default"
        onClick={() => document.body.click()}>Cancel</Button>
      <Button
        bsStyle="primary"
        className="btn-blue popover-confirm"
        onClick={() => this.props.removeTradeHistory({ tradeHistoryId, portfolioId })}>Confirm</Button>
    </Popover>
  );

  rightClickSell = ({ buyPrice, symbol }) => {
    this.setState({
      historyModalData: {
        ...this.state.historyModalData,
        tradeType: { label: 'Sell', value: 'Sell' },
        buyPrice: buyPrice || '',
        symbol
      }
    }, () => { this.openAddHistoryModal(); });
  }

  format = (item) => {
    if (!item || isNaN(item)) return '--';
      else return parseFloat(item).toFixed(2);
  }

  calcReturn = (oldPrice, newPrice) => {
    if (isNaN(oldPrice) || isNaN(newPrice) || !oldPrice || !newPrice) 
      return '--';
    else 
      return (newPrice - oldPrice) / oldPrice * 100;
  }

  onTradeHistoryInputChange = (e, tradeId) => {
    this.props.updateTradeHistoryInput({
      value: e.target.value,
      name: e.target.name,
      tradeId: tradeId
    });

    this.props.updateDbTradeHistoryInput({
      value: e.target.value,
      name: e.target.name,
      tradeId: tradeId
    });
  }

  mapHistory = () => {
    return this.props.user.tradeHistoryInfo.map((item, index) => {

      const RightClickSellItem = () => {
        if (item.tradeType === 'Buy') {
          return (
            <Item onClick={() => this.rightClickSell({
              buyPrice: item.buyPrice,
              symbol: item.symbol
            })}>{`Sell ${item.symbol}`}</Item>
          );
        } else return null;
      }

      const TradeHistoryContextMenu = () => (
        <ContextMenu theme={theme.dark} id={`trade-history-context-menu-${item.symbol}${index}`}>
          <RightClickSellItem />
          <Item onClick={() => {
            this.setState({ tradeToRemove: item });
            this.openRemoveHistoryModal();
          }}>Remove</Item>
          <Item>Close</Item>
        </ContextMenu>
      );

      return (
        <Fragment key={item.id}>
          <ContextMenuProvider 
          id={`trade-history-context-menu-${item.symbol}${index}`} 
          component="tr" 
          className={item.tradeType === 'Buy' ? 'positive-price' : 'negative-price'}>
            <td>{item.symbol}</td>
            <td>{item.companyName}</td>
            <td className="no-padding">
              <input 
                onChange={(e) => this.onTradeHistoryInputChange(e, item.id)}
                name="buyPrice"
                className="cell-input" 
                value={item.buyPrice} 
              />
            </td>
            {item.tradeType === 'Sell' ? <td className="no-padding">
              <input 
                onChange={(e) => this.onTradeHistoryInputChange(e, item.id)}
                name="sellPrice"
                className="cell-input" 
                value={item.sellPrice} 
              />
            </td> : <td>{this.format(item.sellPrice)}</td>}
            <td>{formatPercent(this.calcReturn(item.buyPrice, item.sellPrice))}</td>
            <td>{this.format(item.currentPrice)}</td>
            <td>{formatPercent(this.calcReturn(item.tradeType === 'Buy' ? item.buyPrice : 
                item.sellPrice, item.currentPrice))}</td>
            <td>{formatDateYYYYMMDD(item.tradeDate)}</td>
            <td>{item.tradeType}</td>
            <td className="history-remove">
              <OverlayTrigger trigger="click" rootClose placement="top" overlay={this.removeTradeHistoryPopover(item.id, item.portfolio_id)}>
                <Glyphicon glyph="trash" />
              </OverlayTrigger>
            </td>
          </ContextMenuProvider>
          <TradeHistoryContextMenu />
        </Fragment>
      );
    });
  }

  mapHistoryReadonly = () => {
    return this.props.user.tradeHistoryInfo.map((item) => {
      return (
        <tr key={item.id} className={item.tradeType === 'Buy' ? 'positive-price' : 'negative-price'}>
          <td>{item.symbol}</td>
          <td>{item.companyName}</td>
          <td>{this.format(item.buyPrice)}</td>
          <td>{this.format(item.sellPrice)}</td>
          <td>{formatPercent(this.calcReturn(item.buyPrice, item.sellPrice))}</td>
          <td>{this.format(item.currentPrice)}</td>
          <td>{formatPercent(this.calcReturn(item.tradeType === 'Buy' ? item.buyPrice : 
                item.sellPrice, item.currentPrice))}</td>
          <td>{formatDateYYYYMMDD(item.tradeDate)}</td>
          <td>{item.tradeType}</td>
        </tr>
      );
    });
  }

  render() {
    if (this.props.session.activePortfolioUser.privilege === 'readonly') {
      return (
        <Fragment>
          <SubNavTradeHistory
            refreshHistory={this.refreshHistory} 
            openAddTradeHistoryModal={this.showAddHistoryModal} />
          <Grid fluid className="trade-history">
            <Table responsive bordered className="trade-history-table">
              <thead>
                <tr className="header">
                  <th>Fund</th>
                  <th>Company Name</th>
                  <th>Buy Price</th>
                  <th>Sell Price</th>
                  <th>Trade Performance</th>
                  <th>Current Price</th>
                  <th>Missed Performance</th>
                  <th>Date</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody>
                {this.mapHistoryReadonly()}
              </tbody>
            </Table>
          </Grid>
        </Fragment>
      );
    }

    return (
      <Fragment>
        <SubNavTradeHistory
          refreshHistory={this.refreshHistory} 
          openAddTradeHistoryModal={this.openAddHistoryModal} />
        <Grid fluid className="trade-history">

          <AddHistoryModal
            showAddHistoryModal={this.state.showAddHistoryModal}
            closeModal={this.closeAddHistoryModal} 
            historyModalData={this.state.historyModalData} 
            modalInputChange={this.modalInputChange} 
            onDropdownChange={this.onDropdownChange} 
            newTradeHistory={this.newTradeHistory} />

          <RemoveHistoryModal 
            showRemoveHistoryModal={this.state.showRemoveHistoryModal} 
            closeModal={this.closeRemoveHistoryModal} 
            removeTradeHistory={this.props.removeTradeHistory} 
            trade={this.state.tradeToRemove} />

          <Table responsive bordered className="trade-history-table">
            <thead>
              <tr className="header">
                <th>Fund</th>
                <th>Company Name</th>
                <th>Buy Price</th>
                <th>Sell Price</th>
                <th>Trade Performance</th>
                <th>Current Price</th>
                <th>Missed Performance</th>
                <th>Date</th>
                <th>Type</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.mapHistory()}
            </tbody>
          </Table>
        </Grid>
      </Fragment>
    );
  }
}

function mapStateToProps({ user, session }) {
  return {
    user,
    session
  };
}

export default ShowLoading(connect(mapStateToProps, { 
  getTradeHistoryInfo, 
  removeTradeHistory,
  addTradeHistory,
  updateTradeHistoryInput,
  updateDbTradeHistoryInput
})(TradeHistory));
